<script setup>
// The draft's identity tile for a step (the app's draftStepTile; Grant 2026-11-03: "your draft on the web doesn't include
// the icon in its appropriate colour for when I started creating a box league, the same should be true if it was a ladder
// or other competition"): a competition wears its format's icon on its own tint + ink, from utils/formatExplainers (the
// single source, the Your competitions rows' and New competition menu's tile); a membership type, playing area, booking
// rules or scoring system wears the club admin menu's icon on the neutral tile. 36px, 11px corners, 18px icon: the
// Competitions rows' spec (X174/X191).
import {computed} from 'vue';
import {draftStepTile} from '~/utils/setupAssistant';

const props = defineProps({
  step: {type: Object, required: true},
});
const tile = computed(() => draftStepTile(props.step));
const style = computed(() => (tile.value.neutral ? undefined : {background: tile.value.tint, color: tile.value.ink}));
</script>

<template>
  <span class="sst" :class="{'sst--neutral': tile.neutral}" :data-format="tile.format ?? undefined" :style="style" aria-hidden="true">
    <v-icon size="18" :icon="tile.icon"/>
  </span>
</template>

<style scoped lang="scss">
.sst {
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  /* the neutral tile: grey with a charcoal icon, as the contact tiles and the Competitions rows' default */
  &--neutral {
    background: rgb(var(--v-theme-light));
    color: rgb(var(--v-theme-charcoal));
  }
}
</style>
